/**
 * Customer-facing display price.
 *
 * Per business rule: customers always see MAP (Minimum Advertised Price) -
 * the sole price field on a product.
 */
export function getDisplayPrice(product) {
  if (!product) return 0;
  return Number(product.min_advertised_price || 0);
}
